export default __webpack_public_path__ + "static/the_sixth_tape-93016d1119eeefd38dcfe356ba3a9402.mp3";